/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureCollection } from '../../models/feature-collection';
import { MapStationsSearch } from '../../models/map-stations-search';

export interface GetCustomMapStations$Params {
  
    /**
     * The map search options
     */
    body: MapStationsSearch
}

export function getCustomMapStations(http: HttpClient, rootUrl: string, params: GetCustomMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
  const rb = new RequestBuilder(rootUrl, getCustomMapStations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureCollection>;
    })
  );
}

getCustomMapStations.PATH = '/custom/map';
